var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.optionEntityListFormatted,"loading":_vm.loading,"rules":[_vm.validateHasValue],"value":_vm.value,"clearable":"","outlined":"","required":""},on:{"input":value => _vm.$emit('input', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }